import Joi from 'joi';

export const allowanceSchema = Joi.object({
  allowanceName: Joi.string()
    .min(2)
    .max(100)
    .required()
    .messages({
      "string.empty": "Allowance name is required.",
      "string.min": "Allowance name must be at least 2 characters.",
      "string.max": "Allowance name must not exceed 100 characters.",
      "any.required": "Allowance name is required.",
    }),
  allowanceType: Joi.string()
    .valid("percentage", "fixed") // Assuming these are the valid types
    .required()
    .messages({
      "string.empty": "Allowance type is required.",
      "any.invalid": "Allowance type is required.",

      "any.only": "Allowance type must be either 'Percentage' or 'Fixed'.",
      "any.required": "Allowance type is required.",
    }),
    allowanceValue: Joi.number()
    .custom((value, helpers) => {
      const allowanceType = helpers?.prefs?.context?.allowanceType;
      const is_default = helpers?.prefs?.context?.is_default;
  
      if (is_default === true) {
        return value; // No min restriction if is_default is true
      }
  
      if (value < 1) {
        return helpers.error("number.min", { message: "Allowance value must be at least 1." });
      }
  
      if ((is_default === null) && (allowanceType === 'percentage')) {
        if (value < 1 || value > 100) {
          return helpers.error("any.invalid", { message: "For 'Percentage' allowance type, value must be between 1 and 100." });
        }
      }
  
      return value;
    })
    .required()
    .messages({
      "number.base": "Allowance value is required.",
      "number.min": "Allowance value must be at least 1.",
      "any.required": "Allowance value is required.",
      "any.invalid": "If allowance type is 'Percentage', value must be between 1 and 100.",
    }),
  
 
  noWorkNoPay: Joi.boolean()
    .required()
    .messages({
      "any.required": "Pay for is required.",
      "any.invalid": "Pay for is required.",
      "boolean.base": "Pay for is required.",

    }),
  addToGross: Joi.boolean()
  .required()
  .messages({
    "any.required": "Gross Wages field is required.",
  }),  
  isEsiWages: Joi.boolean()
    .required()
    .messages({
      "any.required": "ESI Wages field is required.",
    }),
  isEpfWages: Joi.boolean()
    .required()
    .messages({
      "any.required": "EPF Wages field is required.",
    }),
  status: Joi.boolean()
    .required()
    .messages({
      "any.required": "Status field is required.",
    }),

});
